export const LOCAL_STORAGE_CONST = {
  ORDERED_AFTER_FILTER: 'orderedAfterFilter',
  BILLING_SELECTED_FRACS: 'billingSelectedFracs',
  BILLING_ORDER_IDS: 'billingOrderIds',
  BILLING_FRACS_SORT: 'billingFracsSort',
  GROUP_BY_INVOICE_FILTER: 'groupByInvoiceFilter',
};
